import { render, staticRenderFns } from "./BlacklistVisitor.vue?vue&type=template&id=2b5c7e2a&scoped=true"
import script from "./BlacklistVisitor.vue?vue&type=script&lang=js"
export * from "./BlacklistVisitor.vue?vue&type=script&lang=js"
import style0 from "./BlacklistVisitor.vue?vue&type=style&index=0&id=2b5c7e2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5c7e2a",
  null
  
)

export default component.exports